"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _getProp = _interopRequireDefault(require("../utils/getProp"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var font = function font(size) {
  return (0, _getProp["default"])("font", size);
};

font.h1 = function () {
  return font("h1");
};

font.h2 = function () {
  return font("h2");
};

font.h3 = function () {
  return font("h3");
};

font.h4 = function () {
  return font("h4");
};

font.h5 = function () {
  return font("h5");
};

font.h6 = function () {
  return font("h6");
};

font.base = function () {
  return font("base");
};

font.tiny = function () {
  return font("tiny");
};

font.input = function () {
  return font("input");
};

font.huge = function () {
  return font("huge");
};

font.lineHeight = function () {
  return font("lineHeight");
};

var _default = font;
exports["default"] = _default;